export default "https://assets.egbcdn.net/assets/packs/_/images/poker/poker-scroll-4f2265fb0f53a90539d77810b21d85f7.png";